module.exports = __webpack_public_path__ + "img/fill_white_home.3be2c078.svg";